import { find } from 'lodash/fp';
import { API_URL } from '../../../app-config/constants';
import type Praise from '../../../types/PraiseDto';
import { get, post, put, remove } from '../request';

const prependOnFirstPage = (offset: number, x: Praise, xs: [Praise]) => {
    if (offset === 0) {
        return [x, ...xs];
    }
};

getPraise.operation = 'READ';
getPraise.updateOnCreate = (args: [{ offset: number }], x: Praise, xs: [Praise]) =>
    prependOnFirstPage(args[0].offset, x, xs);
export function getPraise({ offset, limit }: { offset: any; limit: any }) {
    return get(`${API_URL}/praise`, {
        getData: {
            fields: '$message.list',
            limit,
            offset,
        },
    });
}

getPraiseBySomeone.operation = 'READ';
getPraiseBySomeone.updateOnCreate = (
    [{ offset, userId }]: [{ offset: number; userId: string }],
    x: Praise,
    xs: [Praise]
) => {
    if (offset === 0 && x.author && x.author.id === userId) {
        return [x, ...xs];
    }
};
export function getPraiseBySomeone({
    offset,
    limit,
    userId,
    startDate,
    endDate,
}: {
    offset: number;
    limit: number;
    userId: string;
    startDate?: string;
    endDate?: string;
}) {
    return get<any>(`${API_URL}/praise`, {
        getData: {
            fields: '$message.list',
            limit: limit.toString(),
            offset: offset.toString(),
            authorId: userId,
            startDate,
            endDate,
        },
    });
}

getPraiseAboutSomeone.operation = 'READ';
getPraiseAboutSomeone.updateOnCreate = (
    [{ offset, userId }]: [{ offset: number; userId: string }],
    x: Praise,
    xs: [Praise]
) => {
    if (offset === 0 && find(recipient => recipient.id === userId, x.recipients)) {
        return [x, ...xs];
    }
};
export function getPraiseAboutSomeone({
    offset,
    limit,
    userId,
    startDate,
    endDate,
}: {
    offset: number;
    limit: number;
    userId: string;
    startDate?: string;
    endDate?: string;
}) {
    return get<Praise[]>(`${API_URL}/praise`, {
        getData: {
            fields: '$message.list',
            limit: limit.toString(),
            offset: offset.toString(),
            recipientId: userId,
            startDate,
            endDate,
        },
    });
}

getPraiseItem.operation = 'READ';
getPraiseItem.byId = true;
export function getPraiseItem(id: string) {
    return get<Praise>(`${API_URL}/praise/${id}?fields=$message.list`);
}

createPraise.operation = 'CREATE';
export function createPraise(payload: unknown) {
    return post(`${API_URL}/praise`, { postData: payload });
}

updatePraise.operation = 'COMMAND';
export function updatePraise(payload: unknown, id: string) {
    return put(`${API_URL}/praise/${id}`, { postData: payload });
}

updatePraiseInternally.operation = 'UPDATE';
export function updatePraiseInternally(praise: unknown) {
    return Promise.resolve(praise);
}

likePraise.operation = 'COMMAND';
export function likePraise(id: string) {
    return put(`${API_URL}/praise/${id}/upvote`);
}

unlikePraise.operation = 'COMMAND';
export function unlikePraise(id: string) {
    return put(`${API_URL}/praise/${id}/downvote`);
}

removePraise.operation = 'DELETE';
export function removePraise(id: string) {
    return remove(`${API_URL}/praise/${id}`);
}

// Praise Wall
getPraiseForWall.operation = 'READ';
export function getPraiseForWall(token: string) {
    return get(`/api/praise/wall`, { getData: { token } });
}
